// Usuń parametr variant z URL
document.addEventListener('DOMContentLoaded', function() {
  const url = new URL(window.location);
  if (url.searchParams.has('variant')) {
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url);
  }
});
